module.exports = __webpack_public_path__ + "img/Räumen.3cf57830.svg";